import { get, getRawValue } from '../../utils/get';
import { getKeys } from '../../adapters/utils';
import { renderStructureData } from './structured-data/render-structured-data';
export var IDs = {
    MONTH_NUMBER: 'blog-archive.month-number',
    MONTH_NAME: 'blog-archive.month-name',
    YEAR: 'blog-archive.year',
    URL: 'blog-archive.url',
    POST_COUNT: 'blog-archive.post-count',
    CURRENT_PAGE: 'blog-archive.current-page',
    PREV_URL: 'blog-archive.prev-url',
    NEXT_URL: 'blog-archive.next-url',
    TOTAL_PAGES: 'blog-archive.total-pages',
    SD_DISABLED: 'blog-archive.disable-schema',
    SD_JSON_RENDER: 'blog-archive.structured-data.render',
};
var userVisible = [
    IDs.POST_COUNT,
    IDs.URL,
    IDs.MONTH_NAME,
    IDs.MONTH_NUMBER,
    IDs.YEAR,
];
var SchemaTypes = {
    BLOG_ARCHIVE_ITEM_LIST: 'blog-archive-item-list-preset',
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        var numberOfItems = get(item, 'archive.items.numberOfItems');
        var itemUrls = getRawValue(item, 'archive.items.itemUrls') || [];
        var sdDisabled = numberOfItems < 1;
        return _a = {},
            _a[IDs.MONTH_NUMBER] = get(item, 'archive.monthNumber'),
            _a[IDs.MONTH_NAME] = get(item, 'archive.monthName'),
            _a[IDs.YEAR] = get(item, 'archive.year'),
            _a[IDs.URL] = get(item, 'archive.url'),
            _a[IDs.POST_COUNT] = numberOfItems,
            _a[IDs.CURRENT_PAGE] = get(item, 'archive.pagination.currentPage'),
            _a[IDs.PREV_URL] = get(item, 'archive.pagination.prevUrl'),
            _a[IDs.NEXT_URL] = get(item, 'archive.pagination.nextUrl'),
            _a[IDs.TOTAL_PAGES] = get(item, 'archive.pagination.totalPages'),
            _a[IDs.SD_DISABLED] = sdDisabled,
            _a[IDs.SD_JSON_RENDER] = sdDisabled ? {} : renderStructureData(itemUrls),
            _a;
    },
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
};
